module.exports = __webpack_public_path__ + "static/img/sdjq.040856c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdjq.png
// module id = Dq7O
// module chunks = 1